export default "__VITE_ASSET__DzI25Xv4__"